var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          staticStyle: { "margin-top": "20px" },
          attrs: {
            data: _vm.list.value,
            border: "",
            height: "650",
            "row-key": "id",
          },
        },
        [
          _c("el-table-column", {
            attrs: { width: "180", prop: "templateCode", label: "模板代码" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(row.templateCode || "-") +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "templateName", label: "提示名称" },
          }),
          _c("el-table-column", { attrs: { prop: "title", label: "主标题" } }),
          _c("el-table-column", {
            attrs: { prop: "subTitle", label: "副标题" },
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "140" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "auth",
                            rawName: "v-auth",
                            value: "PROMPT_TEMPLATE_EDIT",
                            expression: "'PROMPT_TEMPLATE_EDIT'",
                          },
                        ],
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.edit(row)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "auth",
                            rawName: "v-auth",
                            value: "PROMPT_TEMPLATE_DEL",
                            expression: "'PROMPT_TEMPLATE_DEL'",
                          },
                        ],
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.del(row.id)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("ElementPagination", {
        staticStyle: { "margin-bottom": "20px" },
        attrs: {
          "current-page": _vm.searchParams.current,
          "page-size": _vm.searchParams.size,
          total: _vm.searchParams.total,
          "page-sizes": [10, 20, 30, 40, 50],
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
      _c("EditDialog", { ref: "editDialog", on: { reload: _vm.getList } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }